import React from "react";
import INPUT_LABEL_LIST_DATA from "./data/inputLabelListDate";
import DatePicker from "react-datepicker";
import { HogixxDropbox, PkcdxxDropbox, BsswghDropbox } from "./Dropbox";
import "react-datepicker/dist/react-datepicker.module.css";
import { ko } from "date-fns/locale/ko";
import { convertDateToyyyymmdd, yyyymmddToDate } from "../../util/date";
import { cellInputMapper } from "../../util/mapper";

const GridForm = ({ cellRefs, inputData, setInputData, enter }) => {
    return (
        <div className="border-gray-400 border-b flex py-7">
            <div className="grid xl:grid-cols-7 lg:grid-cols-4 md:grid-cols-3 gap-0 max-w-fit border-black">
                {INPUT_LABEL_LIST_DATA.map((labelName, index) => {
                    return (
                        <LabeledCell
                            refs={cellRefs}
                            keyDown={enter}
                            index={index}
                            inputData={inputData}
                            setInputData={setInputData}
                            labelName={labelName}
                            key={index}
                        />
                    );
                })}
            </div>
            <div className="flex">
                <CellLabel labelName={"상세현황"} />
                <textarea className="w-80 p-1" type="text" />
            </div>
        </div>
    );
};

export default GridForm;

const LabeledCell = ({
    refs,
    keyDown,
    index,
    inputData,
    setInputData,
    labelName,
}) => {
    return (
        <div className="flex">
            <CellLabel labelName={labelName} />
            {CellSelector({
                refs,
                keyDown,
                index,
                inputData,
                setInputData,
                labelName,
            })}
        </div>
    );
};

const CellSelector = ({
    refs,
    keyDown,
    index,
    inputData,
    setInputData,
    labelName,
}) => {
    const handleDateSelect = (date) => {
        setInputData((prev) => ({
            ...prev,
            PPDATE: convertDateToyyyymmdd(date),
        }));
    };
    switch (labelName) {
        case "일자":
            return (
                <DatePicker
                    className="max-w-24 text-sm pt-1 border-b bg-yellow-100 border-r border-l border-black"
                    locale={ko}
                    dateFormat="yyyy/MM/dd"
                    startDate={yyyymmddToDate(inputData.PPDATE)}
                    selected={yyyymmddToDate(inputData.PPDATE)}
                    onChange={(date) => handleDateSelect(date)}
                />
            );
        case "지종":
            return (
                <PkcdxxDropbox
                    keyDown={keyDown}
                    refs={refs}
                    index={index}
                    data={inputData}
                    setData={setInputData}
                />
            );
        case "기준 평량":
            return (
                <BsswghDropbox
                    keyDown={keyDown}
                    refs={refs}
                    index={index}
                    data={inputData}
                    setData={setInputData}
                />
            );
        case "작업 호기":
            return (
                <HogixxDropbox
                    keyDown={keyDown}
                    refs={refs}
                    index={index}
                    data={inputData}
                    setData={setInputData}
                />
            );

        default:
            return (
                <GridCell
                    refs={refs}
                    keyDown={keyDown}
                    index={index}
                    inputData={inputData}
                    setInputData={setInputData}
                    labelName={labelName}
                />
            );
    }
};

const GridCell = ({
    refs,
    keyDown,
    index,
    inputData,
    setInputData,
    labelName,
}) => {
    const handleOnChangeValue = (e) => {
        setInputData((prev) => ({
            ...prev,
            [cellInputMapper[labelName]]: e.target.value,
        }));
    };
    return (
        <div>
            <input
                onKeyDown={(e) => keyDown(e, index)}
                ref={(element) => (refs.current[index] = element)}
                onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(
                            0,
                            e.target.maxLength
                        );
                }}
                className="max-w-24 border-r border-l border-b border-black pl-1 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                type="number"
                pattern={cellValidate(labelName)}
                title="값을 정확히 입력해주세요."
                onChange={handleOnChangeValue}
                maxLength={labelName === "시간" ? 4 : 7}
                value={inputData[cellInputMapper[labelName]] ?? ""}
                disabled={labelName.includes("여분")}
            />
        </div>
    );
};

const CellLabel = ({ labelName }) => {
    return (
        <div className="min-w-28 text-white font-bold border-b border-black bg-blue-500 pl-1 content-center">
            {labelName}
        </div>
    );
};

const cellValidate = (labelName) => {
    switch (labelName) {
        // 3.2
        case "Cobb size":
            return patternGenerator(3, 2);

        // 3.1
        case "실평량":
        case "두께":
            return patternGenerator(3, 1);

        // 2.1
        case "Cobb 온도":
        case "Cobb 습도":
            return patternGenerator(2, 1);

        // 1.3
        case "파강":
        case "파강 Index":
            return patternGenerator(1, 3);

        // 1.2
        case "밀도":
        case "MD/CD":
            return patternGenerator(1, 2);

        case "색상 L":
        case "색상 A":
        case "색상 B":
            return patternGenerator(2, 2);

        // 2.2 (7개)
        default:
            return patternGenerator(2, 2);
    }
};

const patternGenerator = (naturalNumberDigit, decimalPlace) => {
    // eslint-disable-next-line
    return new RegExp(
        `^([1-9]{1}\\d{${
            naturalNumberDigit - 1
        }|0{1})(\\.{1}\\d{1,${decimalPlace}}[1-9]{1})$`,
        "g"
    );
};
